import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js'; // Include the .js extension
import reportWebVitals from './reportWebVitals.js'; // Include the .js extension
import './i18n.js'; // Include the .js extension

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
